import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { routes } from "../../../routes/routesConfig";
import { setDates, setTopN, setComparisonYear, selectDates, selectTopN, selectComparisonYear } from "../../../redux/slices/filtersSlice";
import DateRangeBar from "../../Bars/DateRangeBar";
import HamburgerMenu from "./HamburgerMenu";
import MobileNavModal from "./MobileNavModal";
import FiltersModal from "../../Bars/FiltersModal";
import "./NavbarStyles.css";
import ConfirmPopup from "../../ConfirmNavigation/ConfirmPopup";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);

  // Detección de viewport mobile usando matchMedia API (compatible con viewport virtual)
  // Si estamos en home ('/'), usamos el breakpoint estándar (768px)
  // Si estamos en otras rutas (con DateBar), usamos uno mayor (1350px) para evitar desbordamiento
  const isHome = location.pathname === "/";
  const breakpoint = isHome ? 768 : 1350;

  useEffect(() => {
    // matchMedia usa el viewport CSS, sincronizado con @media queries
    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);

    const checkMobile = (e) => {
      setIsMobile(e.matches);
    };

    // Set inicial
    setIsMobile(mediaQuery.matches);

    // Listener para cambios (método moderno)
    mediaQuery.addEventListener('change', checkMobile);

    return () => mediaQuery.removeEventListener('change', checkMobile);
  }, [breakpoint]);

  // Redux para filtros globales
  const dates = useSelector(selectDates);
  const topN = useSelector(selectTopN);
  const comparisonYear = useSelector(selectComparisonYear);

  const handleDatesChange = (newDates) => {
    dispatch(setDates(newDates));
  };

  const handleTopNChange = (newTopN) => {
    dispatch(setTopN(newTopN));
  };

  /*const handleSelectChange = (e) => {
    const selectedPath = e.target.value;
    if (selectedPath) navigate(selectedPath);
  };*/
  //bloque de aviso
  const [pendingPath, setPendingPath] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const slowRoutes = ["/convivencia"];
  const handleSelectChange = (e) => {
    const selectedPath = e.target.value;

    if (!selectedPath) return;

    if (slowRoutes.includes(selectedPath)) {
      setPendingPath(selectedPath);
      setShowConfirm(true);
    } else {
      navigate(selectedPath);
    }
  };
  const handleConfirm = () => {
    setShowConfirm(false);
    if (pendingPath) navigate(pendingPath);
    setPendingPath("");
  };
  const handleCancel = () => {
    setShowConfirm(false);
    setPendingPath("");
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const openFilters = () => {
    setIsFiltersOpen(true);
  };

  const closeFilters = () => {
    setIsFiltersOpen(false);
  };

  const handleNavigate = (path) => {
    if (!path) return;

    if (slowRoutes.includes(path)) {
      setPendingPath(path);
      setShowConfirm(true);
      setIsMenuOpen(false);
    } else {
      navigate(path);
      setIsMenuOpen(false);
    }
  };

  const handleApplyFilters = (newDates, newTopN, newComparisonYear) => {
    dispatch(setDates(newDates));
    dispatch(setTopN(newTopN));
    if (newComparisonYear) {
      dispatch(setComparisonYear(newComparisonYear));
    }
  };


  return (
    <nav className={`navbar ${isMobile ? 'is-mobile' : ''}`}>
      {/* Desktop Layout */}
      {!isMobile && (
        <>
          <div className="navbar-brand">
            <span className="navbar-title">Indicadores de Seguridad</span>
          </div>

          {/* Filtros globales - DateRangeBar integrado */}
          {location.pathname !== "/" && (
            <div className="navbar-filters">
              <DateRangeBar
                dates={dates}
                setDates={handleDatesChange}
                onChange={handleDatesChange}
                topN={topN}
                setTopN={handleTopNChange}
                showToggle={location.pathname === "/homicidios"}
                showHurtoTypeFilter={location.pathname === "/hurtos"}
              />
            </div>
          )}

          <div className="navbar-center">
            <select
              className="navbar-select"
              value={location.pathname}
              onChange={handleSelectChange}
            >
              <option value="">Selecciona una sección...</option>
              {routes.map(({ path, label }) => (
                <option key={path} value={path}>
                  {label}
                </option>
              ))}
            </select>
          </div>
        </>
      )}

      {/* Mobile Layout */}
      {isMobile && (
        <>
          <div className="navbar-brand">
            <span className="navbar-title">Indicadores de Seguridad</span>
            <HamburgerMenu isOpen={isMenuOpen} toggleMenu={toggleMenu} />
          </div>

          {/* Modal Navegación Mobile */}
          <MobileNavModal
            isVisible={isMenuOpen}
            onClose={() => setIsMenuOpen(false)}
            onOpenFilters={location.pathname !== "/" ? openFilters : null}
            routes={routes}
            currentPath={location.pathname}
            onNavigate={handleNavigate}
          />

          {/* Modal Filtros Mobile */}
          <FiltersModal
            isVisible={isFiltersOpen}
            onClose={closeFilters}
            dates={dates}
            topN={topN}
            comparisonYear={comparisonYear}
            onApply={handleApplyFilters}
            showFeminicidiosToggle={location.pathname === "/homicidios"}
            showHurtoTypeFilter={location.pathname === "/hurtos"}
          />
        </>
      )}

      {/* Popup de confirmación (ambos modos) */}
      <ConfirmPopup
        visible={showConfirm}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </nav>
  );
};

export default Navbar;
